import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/workspace/frontend/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/workspace/frontend/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/workspace/frontend/layouts/empty.vue").then(m => m.default || m)),
  firstlayout: defineAsyncComponent(() => import("/workspace/frontend/layouts/firstlayout.vue").then(m => m.default || m)),
  onboarding: defineAsyncComponent(() => import("/workspace/frontend/layouts/onboarding.vue").then(m => m.default || m))
}